/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@avalara/skylab-sdk/loader';
defineCustomElements();
export const AuiContentSwitcher = /*@__PURE__*/ createReactComponent('aui-content-switcher');
export const AuiErrorPage = /*@__PURE__*/ createReactComponent('aui-error-page');
export const AuiFooter = /*@__PURE__*/ createReactComponent('aui-footer');
export const AuiHeader = /*@__PURE__*/ createReactComponent('aui-header');
export const AuiIcon = /*@__PURE__*/ createReactComponent('aui-icon');
export const AuiIeBanner = /*@__PURE__*/ createReactComponent('aui-ie-banner');
export const AuiImage = /*@__PURE__*/ createReactComponent('aui-image');
export const AuiInviteUserDialog = /*@__PURE__*/ createReactComponent('aui-invite-user-dialog');
export const AuiLocaleSwitcher = /*@__PURE__*/ createReactComponent('aui-locale-switcher');
export const AuiServiceNotification = /*@__PURE__*/ createReactComponent('aui-service-notification');
export const AuiSessionTimeout = /*@__PURE__*/ createReactComponent('aui-session-timeout');
export const AuiSidenav = /*@__PURE__*/ createReactComponent('aui-sidenav');
export const AuiSubscriptionCountdown = /*@__PURE__*/ createReactComponent('aui-subscription-countdown');
export const AuiSubscriptionExpiration = /*@__PURE__*/ createReactComponent('aui-subscription-expiration');
export const AuiSupernav = /*@__PURE__*/ createReactComponent('aui-supernav');
export const AuiTrialProducts = /*@__PURE__*/ createReactComponent('aui-trial-products');
export const AuiUploader = /*@__PURE__*/ createReactComponent('aui-uploader');
export const SAccordionContained = /*@__PURE__*/ createReactComponent('s-accordion-contained');
export const SAccordionSingle = /*@__PURE__*/ createReactComponent('s-accordion-single');
export const SAccordionStacked = /*@__PURE__*/ createReactComponent('s-accordion-stacked');
export const SAlert = /*@__PURE__*/ createReactComponent('s-alert');
export const SBadge = /*@__PURE__*/ createReactComponent('s-badge');
export const SBanner = /*@__PURE__*/ createReactComponent('s-banner');
export const SBox = /*@__PURE__*/ createReactComponent('s-box');
export const SBreadcrumbs = /*@__PURE__*/ createReactComponent('s-breadcrumbs');
export const SCardAction = /*@__PURE__*/ createReactComponent('s-card-action');
export const SCardNavigation = /*@__PURE__*/ createReactComponent('s-card-navigation');
export const SCardSelection = /*@__PURE__*/ createReactComponent('s-card-selection');
export const SCol = /*@__PURE__*/ createReactComponent('s-col');
export const SColumnManager = /*@__PURE__*/ createReactComponent('s-column-manager');
export const SContainer = /*@__PURE__*/ createReactComponent('s-container');
export const SDatepicker = /*@__PURE__*/ createReactComponent('s-datepicker');
export const SDemo = /*@__PURE__*/ createReactComponent('s-demo');
export const SDialog = /*@__PURE__*/ createReactComponent('s-dialog');
export const SDropdown = /*@__PURE__*/ createReactComponent('s-dropdown');
export const SFiltersPanel = /*@__PURE__*/ createReactComponent('s-filters-panel');
export const SHeaderSortable = /*@__PURE__*/ createReactComponent('s-header-sortable');
export const SIcon = /*@__PURE__*/ createReactComponent('s-icon');
export const SInputExtended = /*@__PURE__*/ createReactComponent('s-input-extended');
export const SLoader = /*@__PURE__*/ createReactComponent('s-loader');
export const SMenu = /*@__PURE__*/ createReactComponent('s-menu');
export const SPagination = /*@__PURE__*/ createReactComponent('s-pagination');
export const SPopper = /*@__PURE__*/ createReactComponent('s-popper');
export const SProgress = /*@__PURE__*/ createReactComponent('s-progress');
export const SRadiogroup = /*@__PURE__*/ createReactComponent('s-radiogroup');
export const SRow = /*@__PURE__*/ createReactComponent('s-row');
export const SRowActions = /*@__PURE__*/ createReactComponent('s-row-actions');
export const SRowExpander = /*@__PURE__*/ createReactComponent('s-row-expander');
export const SSelect = /*@__PURE__*/ createReactComponent('s-select');
export const SStepper = /*@__PURE__*/ createReactComponent('s-stepper');
export const STabs = /*@__PURE__*/ createReactComponent('s-tabs');
export const STag = /*@__PURE__*/ createReactComponent('s-tag');
export const SToast = /*@__PURE__*/ createReactComponent('s-toast');
export const SToasts = /*@__PURE__*/ createReactComponent('s-toasts');
export const SToggle = /*@__PURE__*/ createReactComponent('s-toggle');
export const STooltip = /*@__PURE__*/ createReactComponent('s-tooltip');
export const STray = /*@__PURE__*/ createReactComponent('s-tray');
export const SUploader = /*@__PURE__*/ createReactComponent('s-uploader');
